//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FCImage from '~/components/FCImage.vue';
import WarrantyUpsell from '~/components/products/WarrantyUpsell.vue';

export default {
  name: 'Products_Upsell',
  components: {
    FCImage,
    WarrantyUpsell,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedUpsellItems: [],
      isActive: false,
      checked: false,
    };
  },
  computed: {
    totalAmount() {
      let total = this.product.price;
      this.selectedUpsellItems.forEach((item) => {
        total += item.product.price;
      });

      return total;
    },
    formattedTotal() {
      return (this.totalAmount / 100);
    },
    checkBoxClass() {
      const classes = [];

      if (this.checked) {
        classes.push('checked');
      }

      return classes;
    },
    hasWarranty() {
      return Object.keys(this.product?.warranty ?? []).length > 0;
    },
  },
  watch: {
    totalAmount(newTotal) {
      this.$emit('totalAmount', newTotal);
    },
  },
  methods: {
    findQuantity(itemId) {
      const filteredItems = this.selectedUpsellItems.filter((item) => item.itemId === itemId);
      return filteredItems.length;
    },
    addUpsellItem(item) {
      this.selectedUpsellItems.push(item);
      this.$emit('selectedItems', this.selectedUpsellItems);
    },
    removeUpsellItem(variantId) {
      const index = this.selectedUpsellItems.findIndex((item) => item.itemId === variantId);

      this.selectedUpsellItems.splice(index, 1);
      this.$emit('selectedItems', this.selectedUpsellItems);
    },
    toggleItem(item) {
      if (this.checked) {
        this.removeUpsellItem(item.itemId);
        this.toggleChecked();
      } else {
        this.addUpsellItem(item);
        this.toggleChecked();
      }
    },
    toggleChecked() {
      this.checked = !this.checked;
    },
    toggleUpsellVariants() {
      this.isActive = !this.isActive;
    },
    getPrice(item) {
      return this.$options.filters.currency2(item.product.price);
    },
  },
};
